import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { SpinnerLoader } from 'shared/ui'
import { type ITagItem } from 'widgets/FilterEditor/ui/Widget/WidgetAsyncTags/store/TagControl'
import styles from './styles.module.scss'

type IWidgetTagsTriggerProps = {
  selectedItems: ITagItem[]
  showValuesWarning: boolean
  loading: boolean
}

export const WidgetTagsTrigger: FC<IWidgetTagsTriggerProps> = observer(
  ({ selectedItems, showValuesWarning, loading }) => {
    const selectedItemsCount = selectedItems.length

    if (loading) return <SpinnerLoader ariaLabel={'WidgetTagsTrigger'} size={16} />

    const labelCount = () => {
      if (!selectedItemsCount) return 'select'

      if (selectedItemsCount === 1) {
        const item = selectedItems[0]

        return item.name
      }

      return `${selectedItemsCount} tags`
    }

    return (
      <div
        className={classNames(styles.selectTriggerComponent, {
          [styles.warning]: showValuesWarning,
        })}
      >
        {labelCount()}
      </div>
    )
  }
)
